import { Flex, Button } from '@applyboard/crystal-ui';
import { useApplicationCards, useAppProcessing } from '~/pages/ApplicationDetails/context';
import { VisaForecast } from './VisaForecast';

export function CardControlActions() {
  const { expandAll, collapseAll, allExpanded, allCollapsed } = useApplicationCards();
  const { application } = useAppProcessing();
  const showVisaForecastComponent = application?.visaProbability;

  return (
    <Flex align="stretch" as="div" gap={5} justify="between">
      <Flex as="div">
        <Button emphasis="transparent" disabled={allExpanded} onClick={() => expandAll()}>
          Expand all
        </Button>
        <Button disabled={allCollapsed} onClick={() => collapseAll()} emphasis="transparent">
          Collapse all
        </Button>
      </Flex>

      {showVisaForecastComponent ? <VisaForecast /> : null}
    </Flex>
  );
}
